// Imports
import $ from "jquery";
import BpmnModeler from "bpmn-js/lib/Modeler";
import {
  BpmnPropertiesPanelModule,
  BpmnPropertiesProviderModule,
} from "bpmn-js-properties-panel";
import convert from "xml-js";
import { debounce } from "min-dash";
import decisionModdleDescriptor from "./descriptors/decision.json";
import decisionPropertiesProviderModule from "./provider/decision";
import gridModule from "diagram-js-grid";
import { open as openBrixxProcessMessage } from "./util/BrixxProcessMessage";
import processModdleDescriptor from "./descriptors/process.json";
import processPropertiesProviderModule from "./provider/process";
import processPublishProviderModule from "./provider/publish";
import { saveAs } from "file-saver";
import scriptPropertiesProviderModule from "./provider/script";
import sendModdleDescriptor from "./descriptors/send.json";
import sendPropertiesProviderModule from "./provider/send";
import servicePropertiesProviderModule from "./provider/service";
import { showSaveFilePicker } from "file-system-access";
import workerModdleDescriptor from "./descriptors/worker.json";

// Styles
import "../styles/app.less";

// Event listener
window.addEventListener(
  "beforeunload",
  (event) => {
    event.preventDefault();
    return (event.returnValue = "Are you sure you want to leave the page?");
  },
  { capture: true }
);

// Configuration
global.serverURL = "http://localhost:5000";
global.baseRoute = "/brixx";
global.credentials = { user: "", password: "" };
if (window.location.hostname === "localhost") {
  global.publishEnabled = true;
  global.tryoutButtonsDisabled = false;
} else {
  global.publishEnabled = false;
  global.tryoutButtonsDisabled = true;
}

global.openProcessModel = async function () {
  var input = $(fileInput);

  input.val("");
  input.trigger("click");
};

global.downloadProcessModel = async function () {
  const { xml } = await bpmnModeler.saveXML({ format: true });
  const blob = new Blob([xml], { type: "text/plain;charset=utf-8" });
  const fileName = "diagram.bpmn";
  if (window.showSaveFilePicker) {
    const fileHandle = await showSaveFilePicker({
      _preferPolyfill: false,
      suggestedName: fileName,
      types: [
        { accept: { "text/plain": [".bpmn"] } },
        { accept: { "application/xml": [".xml"] } },
      ],
      excludeAcceptAllOption: false,
    });
    // await blob.stream().pipeTo(fileHandle.createWritable())
    // const handle = await showSaveFilePicker();
    const writable = await fileHandle.createWritable();
    await writable.write(blob);
    writable.close();
  } else {
    saveAs(blob, fileName);
  }
};

global.publishProcessModel = async function () {
  if (publishEnabled) {
    openBrixxProcessMessage(
      `Publish information<br />Start publish model ...<br />Brixx-Process-Engine`
    );
    const { xml } = await bpmnModeler.saveXML({ format: true });
    const result = await sendDiagram(xml);

    openBrixxProcessMessage(
      `Publish information<br />${result.status}<br />Brixx-Process-Engine`
    );
  } else {
    openBrixxProcessMessage(
      `Publish process model is disabled in BPMN editor online tryout version`,
      false
    );
  }
};

global.publishProcessScript = async function (fileName = null) {
  if (publishEnabled) {
    $("#file-input").on("change", async (e) => {
      openBrixxProcessMessage(
        `Publish information<br />Start publish script ...<br />Brixx-Process-Engine`
      );
      const serverRoute = serverURL + baseRoute;
      const url = serverRoute + "/publish/script";
      const formData = new FormData();
      formData.append("file", e.target.files[0], fileName);

      const result = {
        success: true,
        status: "",
      };

      const token = await getToken();
      if (token) {
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            body: formData,
          });

          result.status = (await response.json()).status;
        } catch (error) {
          // Handle error
          // console.log(error);
          // throw new Error(error);
          result.success = false;
          result.status = "Network connection error";
        }
      } else {
        result.success = false;
        result.status = "Authorization error";
      }

      openBrixxProcessMessage(
        `Publish information<br />${result.status}<br />Brixx-Process-Engine`
      );
    });
    $("#file-input").trigger("click");
  } else {
    openBrixxProcessMessage(
      `Publish process script is disabled in BPMN editor online tryout version`,
      false
    );
  }
};

global.publishProcessService = async function (fileName = null) {
  if (publishEnabled) {
    $("#file-input").on("change", async (e) => {
      openBrixxProcessMessage(
        `Publish information<br />Start publish service ...<br />Brixx-Process-Engine`
      );
      const serverRoute = serverURL + baseRoute;
      const url = serverRoute + "/publish/service";
      const formData = new FormData();
      formData.append("file", e.target.files[0], fileName);

      const result = {
        success: true,
        status: "",
      };

      const token = await getToken();
      if (token) {
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            body: formData,
          });

          result.status = (await response.json()).status;
        } catch (error) {
          // Handle error
          // console.log(error);
          // throw new Error(error);
          result.success = false;
          result.status = "Network connection error";
        }
      } else {
        result.success = false;
        result.status = "Authorization error";
      }

      openBrixxProcessMessage(
        `Publish information<br />${result.status}<br />Brixx-Process-Engine`
      );
    });
    $("#file-input").trigger("click");
  } else {
    openBrixxProcessMessage(
      `Publish process service is disabled in BPMN editor online tryout version`,
      false
    );
  }
};

global.publishMailBody = async function (fileName = null) {
  if (publishEnabled) {
    $("#file-input").on("change", async (e) => {
      openBrixxProcessMessage(
        `Publish information<br />Start publish mail body ...<br />Brixx-Process-Engine`
      );
      const serverRoute = serverURL + baseRoute;
      const url = serverRoute + "/publish/body";
      const formData = new FormData();
      formData.append("file", e.target.files[0], fileName);

      const result = {
        success: true,
        status: "",
      };

      const token = await getToken();
      if (token) {
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            body: formData,
          });

          result.status = (await response.json()).status;
        } catch (error) {
          // Handle error
          // console.log(error);
          // throw new Error(error);
          result.success = false;
          result.status = "Network connection error";
        }
      } else {
        result.success = false;
        result.status = "Authorization error";
      }

      openBrixxProcessMessage(
        `Publish information<br />${result.status}<br />Brixx-Process-Engine`
      );
    });
    $("#file-input").trigger("click");
  } else {
    openBrixxProcessMessage(
      `Publish mail body is disabled in BPMN editor online tryout version`,
      false
    );
  }
};

global.checkServerHeartbeat = async function () {
  const result = {
    success: true,
    status: "",
  };

  const token = await getToken();
  if (token) {
    try {
      const serverRoute = serverURL + baseRoute;
      const url = serverRoute + "/heartbeat";
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const info = await response.json();
      result.appname = info.appname;
      result.version = info.version;
      result.status = info.status;
    } catch (error) {
      // Handle error
      console.log(error);
      // throw new Error(error);
      result.success = false;
      result.status = "Network connection error";
    }
  } else {
    result.success = false;
    result.status = "Authorization error";
  }

  if (result.success) {
    openBrixxProcessMessage(
      `Status information<br />Version: ${result.version}<br />Status: ${result.status}<br />Brixx-Process-Engine`
    );
  } else {
    openBrixxProcessMessage(
      `Status information<br />${result.status}<br />Brixx-Process-Engine`
    );
  }
};

var container = container || $("#js-drop-zone");

var bpmnModeler = new BpmnModeler({
  container: "#js-canvas",
  propertiesPanel: {
    parent: "#js-properties-panel",
  },
  additionalModules: [
    BpmnPropertiesPanelModule,
    BpmnPropertiesProviderModule,
    decisionPropertiesProviderModule,
    processPropertiesProviderModule,
    processPublishProviderModule,
    scriptPropertiesProviderModule,
    sendPropertiesProviderModule,
    servicePropertiesProviderModule,
    gridModule,
  ],
  moddleExtensions: {
    decision: decisionModdleDescriptor,
    process: processModdleDescriptor,
    send: sendModdleDescriptor,
    worker: workerModdleDescriptor,
  },
});

function getElementId({ prefix = "Element", template = "_xxxxxxx" }) {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  return `${prefix}${template.replace(/[xy]/g, (c) => {
    let r = chars.charAt(Math.floor(Math.random() * chars.length));
    return c === "x" ? r : c;
  })}`;
}

function openFile(file, callback) {
  // check file api availability
  if (!window.FileReader) {
    return window.alert(
      "Looks like you use an older browser that does not support drag and drop. " +
        "Try using a modern browser such as Chrome, Firefox or Internet Explorer > 10."
    );
  }

  // no file chosen
  if (!file) {
    return;
  }

  var reader = new FileReader();

  reader.onload = function (e) {
    var xml = e.target.result;

    callback(xml);
  };

  reader.readAsText(file);
}

var idProcess = getElementId({ prefix: "Process" });
var idStartEvent = getElementId({ prefix: "Event" });

// Not yet used
// <bpmn2:process id="${idProcess}" isExecutable="false" brixx-process:version="1" brixx-process:url="http://localhost:5000">

var diagramXML = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:brixx-decision="https://brixx.it/decision" xmlns:brixx-process="https://brixx.it/process" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd">
  <bpmn2:process id="${idProcess}" isExecutable="false">
    <bpmn2:startEvent id="${idStartEvent}"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="${idProcess}">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="${idStartEvent}">
        <dc:Bounds height="36.0" width="36.0" x="412.0" y="240.0"/>
      </bpmndi:BPMNShape>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn2:definitions>`;

var fileInput = $('<input type="file" />')
  .appendTo(document.body)
  .css({
    width: 1,
    height: 1,
    display: "none",
    overflow: "hidden",
  })
  .on("change", function (e) {
    openFile(e.target.files[0], openDiagram);
  });

async function openDiagram(xml) {
  try {
    await bpmnModeler.importXML(xml);

    container.removeClass("with-error").addClass("with-diagram");
  } catch (err) {
    container.removeClass("with-diagram").addClass("with-error");

    container.find(".error pre").text(err.message);

    console.error(err);
  }
}

async function getToken() {
  const serverRoute = serverURL + baseRoute;
  const url = serverRoute + "/login";
  let token = null;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    token = (await response.json()).token;
  } catch (error) {
    // Handle error
    console.log(error);
    // throw new Error(error);
  }

  return token;
}

function startEditor(xml) {
  container.removeClass("with-error").addClass("with-diagram");

  openDiagram(diagramXML);
}

const sendDiagram = async (xml) => {
  const diagram = convert.xml2json(xml, { compact: false, spaces: 4 });
  const process = JSON.parse(diagram).elements[0].elements[0];
  const serverRoute =
    (process.attributes["brixx-process:url"] || serverURL) + baseRoute;

  const result = {
    success: true,
    status: "",
  };

  const token = await getToken();
  if (token) {
    try {
      const url = serverRoute + "/publish/model";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ diagram }),
      });

      result.status = (await response.json()).status;
    } catch (error) {
      // Handle error
      // console.log(error);
      // throw new Error(error);
      result.success = false;
      result.status = "Network connection error";
    }
  } else {
    result.success = false;
    result.status = "Authorization error";
  }

  return result;
};

$(function () {
  var openDiagrammFile = $("#js-open-diagram");
  var createNewDiagramm = $("#js-create-diagram");
  var downloadDiagrammFile = $("#js-download-diagram");
  var downloadDiagrammImage = $("#js-download-image");
  var publishDiagramm = $("#js-publish-diagram");
  var buttonToggleLabel = document.getElementById("js-button-toggle-label");
  if (publishEnabled) {
    $("#js-icon-publish")
      .removeClass("icon-publish-disabled")
      .addClass("icon-publish");
  }

  buttonToggleLabel.innerHTML = "PROPERTIES";

  $(".slideout-menu-toggle, .toggle").on("click", function (e) {
    e.preventDefault();
    var $slideoutMenu = $(".slideout-menu");
    var $slideoutMenuWidth = $slideoutMenu.width();

    $slideoutMenu.toggleClass("open");

    if ($slideoutMenu.hasClass("open")) {
      $slideoutMenu.animate({ right: -0 });
    } else {
      $slideoutMenu.animate({ right: -($slideoutMenuWidth + 6) }, 250);
    }
  });

  openDiagrammFile.click(function (e) {
    openProcessModel();
  });

  createNewDiagramm.click(function (e) {
    openDiagram(diagramXML);
  });

  downloadDiagrammFile.click(function (e) {
    downloadProcessModel();
  });

  downloadDiagrammImage.click(async function (e) {
    const { svg } = await bpmnModeler.saveSVG();

    var blob = new Blob([svg], { type: "text/plain;charset=utf-8" });
    saveAs(blob, "diagram.svg");
  });

  publishDiagramm.click(function (e) {
    publishProcessModel();
  });

  var exportArtifacts = debounce(async function () {}, 500);

  bpmnModeler.on("commandStack.changed", exportArtifacts);

  global.extensions = {};
  fetch("./extensions/extensions.json")
    .then(async (response) => {
      try {
        extensions = await response.json();
      } catch (error) {
        // console.log(error);
      }
    })
    .then((response) => {
      startEditor();
    });
});
